module.exports = __webpack_public_path__ + "img/about-banner.1428e4f2.png";